module.exports = __webpack_public_path__ + "static/media/Hellbirds.66c545b6.png";